export default {
  required: "Il campo è obbligatorio",
  minLength: param => `Il campo ha lunghezza minima di ${param} caratteri`,
  maxLength: param => `Il campo ha lunghezza massima di ${param} caratteri`,
  email: "La e-mail inserita non è valida",
  sameAs: "Le password non coincidono",
  fileSize: "La lunghezza massima consentita per l'invio è 2 MB",
};
